import * as React from 'react';
import { useState } from 'react';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import DialogActions from '@mui/material/DialogActions';
import CircularProgress from '@mui/material/CircularProgress'
import { deleteHardwareModel } from '../../services/service'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

export default function DeleteHardwareModelModal(props) {
  const [loading, setLoading] = useState(false);
  const { hardwareModel, show, onClose, loadTable, changeSelectedRowValue } = props

  const deleteAndCloseHardwareModal = () => {
    hardwareModel.map(item => deleteHardwareModel(item['id']).then((response) => {
      loadTable()
      setLoading(true)
      changeSelectedRowValue(true)
    }).finally((resp) => {
      setLoading(false)
      onClose()
      changeSelectedRowValue(false)
    })
    )
  }

  console.log('hardwareModel.lenght')

  console.log(hardwareModel.length)

  return (
    <div>
      <Modal
        open={show}
        onClose={onClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} style={{ borderStyle: 'hidden', minWidth: '35rem', borderRadius: '0.5rem' }}>
          {hardwareModel.length > 1
            ? (
              <span>
                Tem certeza que deseja apagar todos os {hardwareModel.length} hardware selecionados?
                <ul>
                  {hardwareModel.map(el => (
                    <li>{el.model}</li>
                  ))}
                </ul>
              </span>
            )
            : <span>Tem certeza que deseja apagar o modelo de hardware: <strong>{hardwareModel[0].model}</strong>? </span>
          }
          <DialogActions>
            <Button
              onClick={onClose}
              style={{ right: '1.5rem' }}>
              Fechar
            </Button>
            <Button
              variant="contained"
              onClick={() => deleteAndCloseHardwareModal()}
              style={{ right: '1rem' }}>
              {loading ? <CircularProgress /> : 'Deletar'}
            </Button>
          </DialogActions>
        </Box>
      </Modal>
    </div>
  );
}